"use client"

import {
  Toast,
  ToastAction,
  ToastClose,
  ToastProvider,
  ToastViewport,
} from "@/components/organisms/feedback/toast"
import { useToast } from "@/components/organisms/feedback/use-toast"
import { Label } from "../../atoms/texts/label";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";

export function Toaster() {
  const { toasts } = useToast()

  return (
    (<ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          (<Toast key={id} variant={variant} {...props}>
            <div className="grid gap-1 z-50">
              {title && <Label message={title} fontWeight="bold">{title}</Label>}
              {description && (<Label message={description}>{description}</Label>)}
            </div>
             {action || (variant === 'error' && description) && (
                            <ToastAction
                                altText={description}
                                onClick={async () => {
                                    await navigator.clipboard.writeText(description);
                                }}
                                className="border-0 p-2 m-0"
                            >
                                <ContentCopyRoundedIcon />
                            </ToastAction>
                        )}


            <ToastClose />
          </Toast>)
        );
      })}
      <ToastViewport />
    </ToastProvider>)
  );
}
